import { gql } from '@apollo/client';
import { useMutation } from 'platform/useMutation';
import { useObservability } from 'shared/helpers/observability';

import {
  UpdateLeadCustomerPhoneNumber,
  UpdateLeadCustomerPhoneNumberVariables,
} from 'sellDirect/graphql/__generated__/UpdateLeadCustomerPhoneNumber';
import { useQualificationContext } from 'shared/helpers/QualificationContext';

export const UPDATE_LEAD_CUSTOMER_PHONE_NUMBER = gql`
  mutation UpdateLeadCustomerPhoneNumber($sellerInputUUID: String!, $phone: String!) {
    seller {
      addPhoneToLeadInitialCustomer(sellerInputUUID: $sellerInputUUID, phone: $phone)
    }
  }
`;

/** TODO: Add documentation */
export const useUpdateLeadPhoneNumber = () => {
  const { sellerInputUUID } = useQualificationContext();
  const { trackError } = useObservability();

  const [update, { loading, data, error }] = useMutation<
    UpdateLeadCustomerPhoneNumber,
    UpdateLeadCustomerPhoneNumberVariables
  >(UPDATE_LEAD_CUSTOMER_PHONE_NUMBER, {
    fetchPolicy: 'no-cache',
    onError: (error) => {
      trackError('update-lead-phone-number', error);
    },
  });

  const updateLeadCustomerPhoneNumber = (phone: string) => {
    return update({
      variables: {
        sellerInputUUID,
        phone,
      },
    });
  };

  return { updateLeadCustomerPhoneNumber, loading, data, error };
};
